import { format as setFormat, subDays, subWeeks, subMonths, subYears } from 'date-fns';
import { DateOutput, SubTimeToDateOptions, SubTimeFunction } from './type';

const subTimeToDate = (
  amountToSub: number,
  subTimeFunction: SubTimeFunction,
  { date = new Date(), format = 'date' }: SubTimeToDateOptions = {},
): DateOutput => {
  const newDate = subTimeFunction(date, amountToSub);
  return format === 'date' ? newDate : setFormat(newDate, format);
};

export const subDaysToDate = (daysToSub: number, options: SubTimeToDateOptions = {}): DateOutput =>
  subTimeToDate(daysToSub, subDays, options);

export const subMonthsToDate = (monthsToSub: number, options: SubTimeToDateOptions = {}) =>
  subTimeToDate(monthsToSub, subMonths, options);

export const subWeeksToDate = (
  weeksToSub: number,
  options: SubTimeToDateOptions = {},
): DateOutput => subTimeToDate(weeksToSub, subWeeks, options);

export const subYearsToDate = (
  yearsToSub: number,
  options: SubTimeToDateOptions = {},
): DateOutput => subTimeToDate(yearsToSub, subYears, options);
